import { core_apimessages_NonUserExperiment } from './rql';
import { isExperimentEnabled } from './user_context_helpers';
import { IUser } from './components/user_context_provider';

// This is manually synced from Experiment::ALL in core:
// https://github.com/reverbdotcom/reverb/blob/master/app/models/experiment.rb
export const nonUserExperiments = {};

// Formats non-user experiment A/B buckets to values expected by `isExperimentEnabled`.
function bucketToValue(bucket) {
  if (bucket === '0') {
    return 'default';
  }

  if (bucket === '1') {
    return 'experiment';
  }

  return bucket || '';
}

export interface Experimentable {
  experiments?: core_apimessages_NonUserExperiment[];
}

// Converts a non-user Experimentable object, such as a Listing fragment
// with experiment data loaded, into a Partial<IUser>, which is the expected
// type for `isExperimentEnabled` and other MParticle tracking code.
export function convertForExperimentBucketing(experimentable: Experimentable): Partial<IUser> {
  const experiments = experimentable.experiments || [];

  const converted = {
    experiments: experiments.map(function (e) {
      return { name: e.name, value: bucketToValue(e.bucket) };
    }),
  };

  return converted;
}

// Uses the same interface and logic as `isExperimentEnabled`, but for non-user based experiments,
// for example a Listing fragment with experiment data loaded.
export function isNonUserExperimentEnabled(experimentable: Experimentable, expName: string): boolean {
  const converted = convertForExperimentBucketing(experimentable);
  return isExperimentEnabled(converted, expName);
}
